<template>
    <v-autocomplete
            :label="label"
            :items="items"
            :value="value"
            :multiple="multiple"
            :chips="chips"
            item-value="AH_UNIMED"
            item-text="AH_DESCES"
            hide-details
            @input="actualizaValor($event)"
            @change="change($event)"
            clearable
            :readonly="readonly"
            :error-messages="errores.collect('um')"
            v-validate="validate"
    >
    </v-autocomplete>
</template>
<script>
    import mixinListas from '../mixins/items';

    export default {
        inject: ['$validator'],
        name: 'micro-unidad-select',
        props: ['multiple', 'value', 'chips', 'readonly', 'validate', 'label'],
        mixins: [mixinListas],
        data() {
            return {
                items: []
            }
        },
        $_veeValidate: {
            value() {
                return this.value;
            }
        },
        mounted() {
            this.itemMicroUM(r => {
                this.items = r;
            }, err => {
                console.log(err)
            })
        },
        methods: {
            actualizaValor(valor) {
                this.$emit('input', valor)
            },
            change(e) {
                this.$emit('change', e);
            },
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/MicroUnidadSelect.vue